<template lang="html">
  <section class="slider row-center">
    <div class="contenedor-slider container">
      <slick ref="slick" :options="slickOptions">
        <div class="slide -one">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
              
              <h3 class="title_ white-text"><span>1/9</span><br>SPACE </h3>

            </div>

          </div>
        </div>

        <div class="slide -second">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
              <h3 class="title_ white-text"><span>2/9</span><br>SPACE </h3>
            </div>

          </div>
        </div>
        
        <div class="slide -three">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
              <h3 class="title_ white-text"><span>3/9</span><br>SPACE </h3>
            </div>

          </div>
        </div>
         <div class="slide -four">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
               <h3 class="title_ white-text"><span>4/9</span><br>SPACE </h3>

            </div>

          </div>
        </div>
         <div class="slide -five">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
             <h3 class="title_ white-text"><span>5/9</span><br>SPACE </h3>

            </div>

          </div>
        </div>
         <div class="slide -six">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
              <h3 class="title_ white-text"><span>6/9</span><br>SPACE </h3>

            </div>

          </div>
        </div>
         <div class="slide -seven">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
               <h3 class="title_ white-text"><span>7/9</span><br>SPACE </h3>

            </div>

          </div>
        </div>
         <div class="slide -eight">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
               <h3 class="title_ white-text"><span>8/9</span><br>SPACE </h3>

            </div>

          </div>
        </div>
         <div class="slide -nine">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
               <h3 class="title_ white-text"><span>9/9</span><br>SPACE </h3>

            </div>

          </div>
        </div>
      </slick>
    </div>
  </section>
</template>

<script lang="js">

  import Slick from 'vue-slick';

  export default  {
   
    data() {
      return {
        slickOptions: {
          slidesToShow: 1,
          arrows : true,
          dots : false,
          autoplay : false,
          slides:9
        },
      }
    },
    components: { Slick },
    methods: {
        next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },

        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },
    }
  }
</script>

<style lang="scss">
.contenedor-slider {
  max-width: 65vw;
  width: 100%;
  position: relative;
  @media screen and(max-width:600px) {
    max-width: 100%;
    background: #ece5dd;
  }
  @media screen and (max-width: 900px) {
    max-width: 100%;
  }
}
.slide {
  text-align: left;
  height: 40vw;
  background: white;
  @media screen and(max-width:800px) {
    height: 70vh;
  }
  .slide-wrapper {
    height: 100%;
    .contenedor-texto {
      height: 100%;
      justify-content: flex-end;
      padding: 40px;
      @media screen and(max-width:600px) {
        max-width: 100%;
      }
    }
  }
  &.-one {
    background: url("/static/img/slider/slide1.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  &.-second {
    background: url("/static/img/slider/slide2.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  &.-three {
    background: url("/static/img/slider/slide3.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  &.-four {
    background: url("/static/img/slider/slide4.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  &.-five {
    background: url("/static/img/slider/slide5.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  &.-six {
    background: url("/static/img/slider/slide6.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  &.-seven {
    background: url("/static/img/slider/slide7.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  &.-eight {
    background: url("/static/img/slider/slide8.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  &.-nine {
    background: url("/static/img/slider/slide9.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
}

.slider {
  // padding: 110px 0 0px 0;
  width: 100%;
  display: inline-block;
  z-index: 4;
  position: relative;
  width: 100%;
  max-width: 65vw;
  @media screen and(max-width:600px) {
    max-width: 100%;
  }
}

.slick-active .contenedor-imagen img {
  opacity: 1;
}

.title_ {
  color: white;
  margin-bottom: 30px;
  width: 100%;
  text-align: left;
  opacity: 0;
  transform: translateX(-100vw);
  transition: 0.8s;
  transition-delay: 0.3s;
  span {
    font-size: 18px;
    margin-bottom: 0;
    line-height: 0;
    padding-left: 10px;
  }
}

.slick-active .title_ {
  opacity: 1;
  transform: translateX(0);
}

.slick-prev.slick-arrow {
  position: absolute;
  bottom: 0;
  background: url("../../../../static/img/flechaleft.svg");
  height: 30px;
  width: 30px;
  left: 45px;
  -webkit-transform: translateY(-30px);
  transform: translateY(-30px);
  z-index: 2;
  background-repeat: no-repeat;
  background-size: 41%;
  background-position: center center;
  border: 1px solid white;
  color: transparent;
}
.slick-next.slick-arrow {
  position: absolute;
  bottom: 0;
  background: url("../../../../static/img/flecharight.svg");
  height: 30px;
  width: 30px;
  left: 92px;
  -webkit-transform: translateY(-30px);
  transform: translateY(-30px);
  z-index: 2;
  background-repeat: no-repeat;
  background-size: 41%;
  background-position: center center;
  border: 1px solid white;
  color: transparent;
}

@media screen and (max-width: 600px) {
  .contenedor-texto {
    width: 100%;
    max-width: 100%;
    padding: 0 10px;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slick-active .subtitle {
    transform: translateX(-0);
    text-align: center;
  }
  .contenedor-texto h4.subtitle,
  .contenedor-texto h3.title_ {
    max-width: 250px;
    text-align: left;
  }
  .slick-active .title_ {
    text-align: center;
  }
  .contenedor-imagen {
    height: auto;
    margin: 0 auto;
  }
  .slider {
    padding-top: 0;
  }
  .slick-arrow::focus {
    outline: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/Home/slider.vue